import {createFeatureSelector} from "@ngrx/store";
import {CustomerState} from "./state";


export const selectCustomer = createFeatureSelector<CustomerState>('customer');
